import { Distance } from './distance';
import z from 'zod';

export const ReceiptItem = z.object({
    /** Sum to be reimbursed */
    sum: z.number().nullish(),
    /** Tax percentage */
    tax: z.number().nullish(),
    /** Distance in case of type=milageAllowance */
    distance: Distance.nullish(),
});
export type ReceiptItem = z.infer<typeof ReceiptItem>;
